import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss'
})
export class SpinnerComponent {
@Input() variant: any;
@Input() size: string = '14px';
@Input() placement: string = 'stand-alone';
@Input() color: string = 'var(--spinner-segment-bg)';
@Input() barColor: string = 'var(--spinner-border-bg)';
}
